import { createUrl } from '../../base-url';

export const AdminEmailSuppressionUrls = {
    getAllSuppression: (baseUrl) => createUrl(baseUrl, 'domain-recipients'),
    resetSuppression: (baseUrl) => createUrl(baseUrl, 'domain-recipients/reset-subscribe-link-attempts'),
};
